var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "row" },
      [
        _c(
          "h6",
          {
            staticClass: "q-pa-md col-12",
            staticStyle: { "padding-bottom": "0" }
          },
          [
            _c("q-icon", { attrs: { color: "primary", name: "fa fa-book" } }),
            _vm._v("Courses\n    ")
          ],
          1
        ),
        _c(
          "q-field",
          { staticClass: "q-pa-md col-12" },
          [
            _c("q-select", {
              attrs: {
                chips: "",
                multiple: "",
                "float-label": "Courses",
                value: _vm.managerCourseIds,
                options: _vm.courseOptions,
                filter: "",
                "autofocus-filter": "",
                disable: !_vm.canEdit
              },
              on: {
                input: function(managerCourseIds) {
                  return this$1.updateManagerForm({
                    field: "COURSES",
                    value: managerCourseIds.map(function(courseId) {
                      return { COURSE_ID: courseId }
                    })
                  })
                }
              }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }